import PropTypes from 'prop-types';
import React from 'react';

import connectEditElementToBriefStore from 'contest/components/connected/connect-edit-element-to-brief-store';
import { connectReadElement, RawHtml } from 'contest/components/brief/read-element';

export const ViewTextElement = connectReadElement(RawHtml, element => ({
    html: element.metadata.formattedText,
}));

export class EditTextElement extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.value !== nextProps.value;
    }

    handleChange(event) {
        this.props.onChange(event.target.value);
    }

    render() {
        return (
            <input
                type="text"
                className="input-text input-width--max"
                defaultValue={this.props.value}
                onChange={this.handleChange}
                onBlur={this.props.onSave}
            />
        );
    }
}
EditTextElement.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
};

export const ConnectedEditTextElement = connectEditElementToBriefStore(
    EditTextElement,
    element => ({
        value: element.value,
    })
);



// WEBPACK FOOTER //
// ./src/web/js/contest/components/brief/text-element.jsx